import { Model, HasOne, BelongsTo, Attr } from 'spraypaint';
import type { PeriodType } from '@common/utils/type.utils';
import ApplicationRecord from '../../ApplicationRecord';
import type AuditsExport from '../AuditsExport';
import type LegalEntity from '../../LegalEntity';

@Model()
class AuditsExportsEmployeesInOutExport extends ApplicationRecord {
  static jsonapiType = 'audits-exports-employees_in_out_exports';

  // Attributes
  @Attr() firstPayslipPeriod!: PeriodType;
  @Attr() lastPayslipPeriod!: PeriodType;
  @Attr() legalEntityId!: string | null;

  // Extra-attributes

  // Relationships
  @HasOne('audits-exports') export!: AuditsExport;
  @BelongsTo() legalEntity?: LegalEntity;
}

export default AuditsExportsEmployeesInOutExport;
